"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = void 0;
var _react = require("react");
var _reactDom = require("react-dom");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const Portal = _ref => {
  let {
    children
  } = _ref;
  const {
    direction = 'rtl'
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const body = document.querySelector('body');
  const el = (0, _react.useRef)(document.createElement('div'));
  (0, _react.useEffect)(() => {
    if (body) {
      el.current.setAttribute('dir', direction);
      body.appendChild(el.current);
      const div = el.current;
      return () => {
        body.removeChild(div);
      };
    }
  }, [body, direction]);
  return /*#__PURE__*/(0, _reactDom.createPortal)(children, el.current);
};
exports.Portal = Portal;